require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-1-edfev.json") })
        }
      }, "path---photos-professional-1-edfev");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-1-edfev!./.cache/json/photos-professional-1-edfev.json
// module id = 529
// module chunks = 231608221292675